import styled from 'styled-components';

export const ErrorMessage = styled.span`
  font-size: 0.8rem;
  margin-left: 1rem;
  margin-top: 0.1rem;
  min-height: 1.2rem;
  color: ${({ theme }) => theme.colors[400]};
`;
